import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "@/utils/helpers";

interface DirectoryParams {
  service_id: string;
  lang_pairs?: string;
  budgetFrom?: string;
  budgetTo?: string;
  budgetType?: string;
  country?: string;
  city?: string;
  search?: string;
  page: number;
  pageSize?: number;
}

interface DirectoryResponse {
  results: any[];
  totalPages: number;
  totalResults: number;
}

interface BusinessParams {
  service_id: string;
  lang_pairs?: string;
  budgetFrom?: string;
  budgetTo?: string;
  budgetType?: string;
  country?: string;
  city?: string;
  search?: string;
  page: number;
  pageSize?: number;
}

interface BusinessResponse {
  businesses: any[];
  totalPages: number;
  totalResults: number;
}

export const directoryApiSlice = createApi({
  reducerPath: "directoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      headers.set("credentials", "include");
      return headers;
    },
  }),
  tagTypes: ["Directory", "Business"],
  endpoints: (builder) => ({
    getDirectoryUsers: builder.query<DirectoryResponse, DirectoryParams>({
      query: (params) => ({
        url: getApiBaseUrl("users", false, {
          ...params,
          pageSize: params.pageSize || 20,
        } as { [key: string]: string | number | boolean | undefined }),
        method: "GET",
      }),
      transformResponse: (response: any): DirectoryResponse => ({
        results: response.results || [],
        totalPages: response.totalPages || 0,
        totalResults: response.totalResults || 0,
      }),
      providesTags: (result, error, params) => [{ type: "Directory", id: JSON.stringify(params) }],
      keepUnusedDataFor: 300,
    }),
    getDirectoryBusinesses: builder.query<BusinessResponse, BusinessParams>({
      query: (params) => ({
        url: getApiBaseUrl("businesses", false, {
          ...params,
          pageSize: params.pageSize || 20,
        } as { [key: string]: string | number | boolean | undefined }),
        method: "GET",
      }),
      transformResponse: (response: any): BusinessResponse => ({
        businesses: response.businesses || [],
        totalPages: response.totalPages || 0,
        totalResults: response.totalResults || 0,
      }),
      providesTags: (result, error, params) => [{ type: "Business", id: JSON.stringify(params) }],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetDirectoryUsersQuery, useGetDirectoryBusinessesQuery } = directoryApiSlice;
